import { Outlet } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { useScrollToTopOnNavigate } from '../../hooks/useScrollToTopOnNavigate';
import styles from './Layout.module.css';

function Layout() {
  useScrollToTopOnNavigate();

  return (
    <div className={styles.app}>
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
